import script from "./shipment-item-finished-good-combobox.vue?vue&type=script&setup=true&lang=js"
export * from "./shipment-item-finished-good-combobox.vue?vue&type=script&setup=true&lang=js"

import "./shipment-item-finished-good-combobox.vue?vue&type=style&index=0&id=40f5cddd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f5cddd"]])

export default __exports__